/* eslint-disable vue/no-use-v-if-with-v-for */
<template>
  <v-container class="d-flex justify-center">
    <v-card :width="cardWidth" :height="cardHeight">
      <h3 class="py-3 pl-4">
        DEVICE LOCATIONS
      </h3>
      <locations :_deviceLocations="_deviceLocations" />
    </v-card>
  </v-container>
</template>

<script>
import { card } from '@/mixins';
import Locations from '@/components/app/Locations';

export default {
  props: ['_deviceLocations'],
  name: 'DeviceMap',
  mixins: [card],
  components: {
    Locations,
  },
};
</script>
